import { Injectable } from '@angular/core';
import { IDBPDatabase } from 'idb';
import { TaskLog } from '@ml/tasks/types/classes/task-log.class';
import { StopLogInterface } from '@ml/tasks/types/interfaces';
import { IdbService } from '@ml/core/services/idb.service';

@Injectable({
  providedIn: 'root'
})
export class TaskIDBService {
  public static readonly dbTasks = 'tasks';
  public static readonly dbLogsTable = 'logs';
  public static readonly dbStopLogsTable = 'logs-stopped';

  constructor(private idbService: IdbService) {
    if (!('indexedDB' in window)) {
      throw new Error('This browser does not support IndexedDB');
    }
  }

  private getId() {
    return new Date().getTime();
  }

  async idbContext(): Promise<IDBPDatabase> {
    return this.idbService.idbContext();
  }

  /**
   * If the log is already created in the IndexedDB, then we'll update the end time
   * If the log is not added in the IndexedDB, we'll added in logs-stopped table
   */
  async stopLog(log: TaskLog, body: StopLogInterface): Promise<TaskLog> {
    const db = await this.idbContext();
    log.end = new Date();
    log.extraInformation = body.extraInformation || '';
    log.measurementUnits = body.measurementUnits || [];

    if (log.idb && log.id) {
      await db.put(TaskIDBService.dbLogsTable, log, log.id);
    } else {
      // Add the log as stopped log
      await db.add(TaskIDBService.dbStopLogsTable, log, log.id);
    }

    return log;
  }

  async saveLog(log: TaskLog): Promise<TaskLog> {
    if (log.id) {
      return;
    }
    log.idb = true;
    log.id = this.getId();
    log.measurementUnits = [];
    log.start = new Date();

    const db = await this.idbContext();
    const tx = db.transaction(TaskIDBService.dbLogsTable, 'readwrite');
    await tx.objectStore(TaskIDBService.dbLogsTable).add(log, log.id);
    await tx.done;

    return log;
  }
}
